export const BLOG_LIMIT = 4

export const BLOG_HEIGHT = '350px'

export const BLOG_SANITY_NAME = 'post'
